/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-11-30 09:30:37
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-13 09:13:30
 */
module.exports = {
    MS_PATIENT_CONSUMMER : "ms-patient-consummer",
    MS_BOSS_CONSUMMER : "ms-boss-consummer",
    MS_IM_CONSUMMER:'ms-im-consummer',
    MS_PROJECT_CONSUMMER:'ms-project-consummer',
    MS_DOCTOR_CONSUMMER:'ms-doctor-consummer'
}


// WEBPACK FOOTER //
// ./src/api/modules/config.js